module.exports = __webpack_public_path__ + "static/media/LSC Logo-White-Horizontal.e0fb2bca.png";